/**
 * Il recupero password deve finire su «Imposta la tua password» (INB-362).
 *
 * Il link dell'email portava dritto nella dashboard, già loggati: l'utente non
 * sceglieva mai una password nuova, e restava con una sessione aperta senza una
 * password nota. Supabase rimanda all'URL di `redirectTo` solo se è nella lista
 * degli URL ammessi; altrimenti ricade sulla Site URL — la radice dell'app, cioè
 * la dashboard — con i token nell'hash, che il client scambia per una sessione.
 * Gli inviti funzionavano perché tornano su `/auth/callback`, ammesso; il
 * recupero tornava su `/update-password`, che evidentemente non lo è.
 *
 * Due difese:
 * - il recupero torna sullo stesso percorso degli inviti,
 *   `/auth/callback?type=recovery`, che mostra lo stesso form;
 * - dovunque atterri, l'evento `PASSWORD_RECOVERY` di supabase-js porta al form.
 */

/** Percorsi che mostrano già il form «Imposta la tua password». */
const PASSWORD_FORM_PATHS = ['/update-password', '/auth/callback'];

/** `redirectTo` per `resetPasswordForEmail`: lo stesso percorso ammesso degli inviti. */
export function passwordRecoveryRedirect(origin: string): string {
	return `${origin}/auth/callback?type=recovery`;
}

/**
 * Dove mandare l'utente a un evento di auth, o `null` per restare: solo un
 * `PASSWORD_RECOVERY` fuori dal form porta al form.
 */
export function passwordRecoveryTarget(event: string, pathname: string): string | null {
	if (event !== 'PASSWORD_RECOVERY') return null;
	return PASSWORD_FORM_PATHS.includes(pathname) ? null : '/update-password';
}
